module.exports = __webpack_public_path__ + "img/close.b2f05768.svg";